const pageOptions = [
  { value: "/", label: "Home" },
  { value: "/hr", label: "HR" },
  { value: "/crm", label: "CRM" },
  { value: "/chat", label: "Chat" },
  { value: "/files", label: "Files" },
  { value: "/esign", label: "eSign" },
  { value: "/blogs", label: "Blogs" },
  { value: "/about", label: "AboutUs" },
  { value: "/projects", label: "Projects" },
  { value: "/worksuite", label: "WorkSuite" },
  { value: "/campaigns", label: "Campaigns" },
  { value: "/community", label: "Community" },
  { value: "/products", label: "Products" },
  { value: "/privacy-policy", label: "PrivacyPolicy" },
  { value: "/files-transfer", label: "FilesTransfer" },
  { value: "/terms-of-service", label: "TermsOfService" },
  { value: "/affiliate-program", label: "AffiliateProgram" },
  { value: "/affiliate-program/join", label: "AffiliateJoin" },
  { value: "/contact", label: "Contact" },
  { value: "/creator", label: "CreatorAI" },
  { value: "/promo", label: "Promo" },
  { value: "/calendar", label: "Calendar" },
  { value: "/offers", label: "Offers" },

  { value: "/host", label: "Host" },
  { value: "/mail", label: "Mail" },
  { value: "/sms", label: "SMS" },
  { value: "/support", label: "Support" },
  { value: "/crew", label: "Crew" },
  { value: "/news", label: "News" },
  { value: "/books", label: "Books" },
  { value: "/cmail", label: "Cmail" },
  { value: "/tax", label: "Tax" },
  { value: "/ads", label: "Ads" },
  { value: "/pitch", label: "Pitch" },
  { value: "/launch", label: "Launch" },
  { value: "/social", label: "Social" },
  { value: "/watsup", label: "Watsup" },
  { value: "/swiprr", label: "Swiprr" },
  { value: "/keptup", label: "KeptUp" },
];

export default pageOptions;
